import './playbookSettings.less'
import { PolicyParameters } from '../policySettings/pages/policyParameters'
import PolicyParametersContextProvider from '../policySettings/context/policyParametersContext'
import EntityProfileFilter from '../policySettings/components/entityProfileFilter/entityProfileFilter'
import { CreateEditPolicyParameters } from '../policySettings/pages/createEditPolicyParameters'
import { BASE_PATH } from '../policySettings/constants'
import { PageHeader, Typography } from '@lightbeamai/design-system'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

export enum PlaybookSettingsTabs {
  entityFilters = 'entity-filters',
  policyParameters = 'policy-parameters'
}

interface IParams {
  id?: PlaybookSettingsTabs
  alertSubPage?: string
}

const PlaybookSettings = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id, alertSubPage }: IParams = useParams()
  const isCreateEditPolicyParameters = alertSubPage && id === PlaybookSettingsTabs.policyParameters
  const [activeTab, setActiveTab] = useState<PlaybookSettingsTabs>(
    PlaybookSettingsTabs.policyParameters
  )

  useEffect(() => {
    if (id) {
      setActiveTab(id)
    }
  }, [id])

  const handleChangeTab = (tab: PlaybookSettingsTabs) => {
    history.push(`${BASE_PATH}/${tab}`)
  }

  return (
    <div className="playbook-settings" data-test-id="playbook-settings">
      <PageHeader title={intl.formatMessage({ id: 'playbook.settings.title' })} variant="simple" />
      <div className="playbook-settings-content">
        <div className="inner-wrapper">
          <div className="settings-menu">
            <Typography as="div" className="menu-item menu-header" type="medium" variant="base">
              {intl.formatMessage({ id: 'sections' })}
            </Typography>
            <Typography
              as="button"
              className={`menu-item tab ${
                activeTab === PlaybookSettingsTabs.policyParameters ? 'active' : ''
              }`}
              type="normal"
              variant="base"
              onClick={() => handleChangeTab(PlaybookSettingsTabs.policyParameters)}
            >
              {intl.formatMessage({ id: 'policy.settings.paramerters' })}
            </Typography>
            <Typography
              as="button"
              className={`menu-item tab ${
                activeTab === PlaybookSettingsTabs.entityFilters ? 'active' : ''
              }`}
              type="normal"
              variant="base"
              onClick={() => handleChangeTab(PlaybookSettingsTabs.entityFilters)}
            >
              {intl.formatMessage({ id: 'playbook.settings.entityFilters' })}
            </Typography>
          </div>
          <div className="content-box">
            {activeTab === PlaybookSettingsTabs.policyParameters && (
              <PolicyParametersContextProvider>
                <PolicyParameters />
                {isCreateEditPolicyParameters && <CreateEditPolicyParameters />}
              </PolicyParametersContextProvider>
            )}
            {activeTab === PlaybookSettingsTabs.entityFilters && <EntityProfileFilter />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlaybookSettings
